import { useLocation, useNavigate } from "react-router-dom";
import { mdiClockTimeFourOutline } from "@mdi/js";
import Icon from "@mdi/react";

import Button from "components/Button";
import Header from "components/Header";
import { routes } from "constants/routes";
import { useUserFeature } from "hooks/useUserFeature";
import MainLayout from "layouts/Main";
import styles from "./style.module.scss";

export default function HaulPayPendingStatus() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { isFactoringApproved } = useUserFeature();

  const isApplyHaulpay = pathname.startsWith("/finance");

  const goDocuments = () => {
    navigate(routes.HAULPAY_UPLOAD_DOCS);
  };

  const ApplicationStatusBody = () => {
    return (
      <div className={styles.applicationStatusBody}>
        <p>
          Thank you for your application for our{" "}
          <span className="font-bold">
            {isApplyHaulpay ? "Haul Pay Services" : "Haul Pay Factoring services"}
          </span>
          . We will update you here as well as via email once your application is processed.
          <br /> <br />
          Please allow 1-2 business days to process your application.
          <br /> <br />
          Once you’re approved, you’ll be able to get paid on your invoices for all loads you move
          from credit qualified shippers and brokers within only a few hours of confirmed
          deliveries!
        </p>

        <div className={styles.applicationStatus}>
          <h3 className="text-xl font-medium">Status:</h3>
          {isFactoringApproved === "pending" || isApplyHaulpay ? (
            <div className={styles.applicationStatusButton}>
              <Icon path={mdiClockTimeFourOutline} className="size-5" />
              <span className="text-xl font-extrabold">PENDING APPROVAL</span>
            </div>
          ) : (
            <span className="text-xl font-extrabold text-error">APPLICATION DECLINED</span>
          )}
        </div>

        <p>
          Once you’re approved, you will have free access to our load board and our invoice
          management tools here!
        </p>

        {isFactoringApproved === "declined" ? (
          <p>
            <span>Please email </span>
            <a href="mailTo:help@haulpay.io" className="text-info">
              help@haulpay.io
            </a>
            <span>
              {" "}
              to send the correct information required so that we can update your application
              information and try to get you approved again. Thank you!
            </span>
          </p>
        ) : null}

        {isApplyHaulpay || isFactoringApproved !== "pending" ? null : (
          <Button className={styles.uploader} onClick={goDocuments}>
            Upload Documents
          </Button>
        )}
      </div>
    );
  };

  return isApplyHaulpay ? (
    <ApplicationStatusBody />
  ) : (
    <MainLayout
      desktopTitle="Finance"
      className="px-5"
      customHeader={<Header canGoBack={false} label="Application Status" />}>
      <ApplicationStatusBody />
    </MainLayout>
  );
}
